import React from "react";

import "../styles/about.css";
import "boxicons";

function Counts({
  name = "Happy Clients",
  number = "7",
  emojiName = "happy",
}) {
  return (
    <div className="count-box">
      <div className="i">
        <box-icon name={emojiName} color="orange" className="i"></box-icon>
      </div>
      <span data-toggle="counter-up">{number}</span>
      <p>{name}</p>
    </div>
  );
}

export default Counts;
